import { cn } from '@/lib/utils'

interface Props {
  size?: number
  animated?: boolean
  className?: string
}

const LOGO_URL = 'https://cosmosfc.org/wp-content/uploads/2022/03/logo.png'

/**
 * Cosmos F.C. crest — uses the real official logo from cosmosfc.org.
 * `animated` prop makes it slowly rotate.
 */
export function CosmosCrest({ size = 64, animated = false, className }: Props) {
  return (
    <div className={cn('inline-block relative', className)} style={{ width: size, height: size }}>
      <img
        src={LOGO_URL}
        alt="Cosmos F.C. crest"
        loading="lazy"
        decoding="async"
        className={cn(
          'w-full h-full object-contain drop-shadow-lg',
          animated && 'motion-safe:animate-spin-slow'
        )}
        style={{ imageRendering: 'auto' }}
      />
    </div>
  )
}
